export const getPolyPath = (polygon) => [
  ...polygon,
  polygon[0], // we need to close the path replicating the first point
]
  .map(x => `${x[0]},${x[1]}`)
  .join('|');

export const getBBoxPath = (bbox) => [
  bbox[0],
  [
    bbox[0][0],
    bbox[1][1],
  ],
  bbox[1],
  [
    bbox[1][0],
    bbox[0][1],
  ],
  bbox[0], // we need to close the path replicating the first point
]
  .map(x => `${x[0]},${x[1]}`)
  .join('|');

export const getCirclePath = (lat, lng, rad, detail = 8) => {
  const r = 6371;
  const pi = Math.PI;
  const cLat = (lat * pi) / 180;
  const cLng = (lng * pi) / 180;
  const d = (rad / 1000) / r;
  
  let staticMapSrc = '';

  for (let i = 0; i <= 360; i += detail) {
    const brng = i * pi / 180;
    let pLat = Math.asin(Math.sin(cLat) * Math.cos(d) + Math.cos(cLat) * Math.sin(d) * Math.cos(brng));
    const pLng = ((cLng + Math.atan2(Math.sin(brng) * Math.sin(d) * Math.cos(cLat), Math.cos(d) - Math.sin(cLat) * Math.sin(pLat))) * 180) / pi;
    pLat = (pLat * 180) / pi;
    staticMapSrc += `|${pLat},${pLng}`;
  }
  return staticMapSrc;
};